import React from 'react';
import { PlusCircle } from 'lucide-react';
import { Button } from "../../ui/Button";
import { useBots } from '@/contexts/BotsContext';
import { formatLocalTime } from '../../utils/backtests';

interface DashboardHeaderProps {
  onCreateBot: () => void;
}

export const DashboardHeader: React.FC<DashboardHeaderProps> = ({ onCreateBot }) => {
  const { currentBot } = useBots();
  
  // Universal bot name and date reading
  const botName = currentBot?.name ?? (currentBot as any)?.bot_name ?? (currentBot as any)?.title ?? null;
  
  const timestamp = (currentBot as any)?.updated_at ?? (currentBot as any)?.updatedAt ?? (currentBot as any)?.created_at ?? (currentBot as any)?.createdAt ?? null;
  
  const dateStr = timestamp ? formatLocalTime(timestamp) : '—';
  const userName = botName ? `${botName} Trader` : "Trader";
  
  return (
    <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-8">
      <div>
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white">Welcome back, {userName}</h1>
        <p className="text-gray-600 dark:text-gray-400">
          {botName ? `Currently editing: ${botName} (${dateStr})` : "Here's what's happening with your bots today."}
        </p>
      </div>
      <div className="mt-4 md:mt-0">
        <Button 
          variant="primary" 
          icon={<PlusCircle size={16}/>}
          iconPosition="left"
          onClick={onCreateBot}
        >
          Create New Bot
        </Button>
      </div>
    </div>
  );
};